// extracted by mini-css-extract-plugin
module.exports = {"socials":"bjmdOC","social":"_3SASBR","bottomLinks":"mwrD5I","bottomLink":"_13ykrf"};